import React, { createContext, useContext, useState, useEffect } from "react";
import { AppContext } from "../../../Context/AppContext";
import AppSettings from "../../../Settings/AppSettings";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import AuthManager from "../../../Common/AuthManager";

export const BuilderContext = createContext(undefined);

export const BuilderContextProvider = ({ children }) => {
  let appData = useContext(AppContext);
  let api_base_url = AppSettings.GMS_BACKEND_API_URL;
  let industryId =
    appData.get_selected_industry() && appData.get_selected_industry().id;
  let partyId = JSON.parse(localStorage.getItem("current_party_id"));
  const [globalFilter, setGlobalFilter] = useState([]);
  const [selectedAttr, setSelectedAttr] = useState([]);

  const [categoriesList, setCategoriesList] = useState([]);
  const [masterdata, setMasterdata] = useState(null);
  let platformInfo = appData.platformInfo;
  const update_cat_attr_list = (selected_categories = null) => {
    if (masterdata) {
      let cat_list = {};
      let attr_list = {};
      let values_list = {};
      for (let cat in masterdata) {
        cat_list[masterdata[cat]["id"]] = masterdata[cat]["name"];
        const cat_attr = masterdata[cat]["attributes"];
        for (let attr in cat_attr) {
          values_list = {};
          let attr_value = cat_attr[attr]["values"];
          for (let val in attr_value) {
            values_list[attr_value[val]["id"]] = attr_value[val]["value"];
          }
          attr_list[cat_attr[attr]["id"]] = {
            name: cat_attr[attr]["name"],
            values: values_list,
          };
        }
      }
      setCategoriesList(cat_list);
      setAttributesList(attr_list);
    }
  };
  const [attributesList, setAttributesList] = useState([]);
  const filter_template = {
    function: "FILTER",
    filter: {
      industries: [industryId],
      categories: [],
      attributes: [],
      values: [],
      operator: "EQ",
    },
  };
  const condition_template = {
    function: "AND",
    conditions: [filter_template, filter_template],
  };
  const component_template = {
    component: {
      definition: JSON.stringify(filter_template),
      description: "",
      display_name: "",
      unique_name: "",
    },
    nessie: "REQUIRED",
    rank: 1,
  };
  const builder_template = {
    builder: {
      description: "",
      name: "",
      uid: "",
    },
    components: [component_template],
  };
  useEffect(() => {
    update_cat_attr_list();
  }, [masterdata]);
  async function getCategories() {
    try {
      let res = await ServiceWrapper.doGet(
        `${api_base_url}industry/${industryId}/category`,
        null,
        null,
        AuthManager.getGmsToken()
      );
      if (!res.errorfound) {
        return res.data.data;
      } else {
        return [];
      }
    } catch (error) {
      return [];
    }
  }
  async function getAttributes() {
    try {
      let res = await ServiceWrapper.doGet(
        `${api_base_url}masterdata/attributes/values/list/${industryId}`,
        null,
        null,
        AuthManager.getGmsToken()
      );

      if (!res.errorfound && res.data) {
        return res.data;
      } else {
        return [];
      }
    } catch (error) {
      return [];
    }
  }

  const load_masterdata = async () => {
    const categories_list = await getCategories();
    //const attributes_list = await getAttributes();
    let final_categories_list = [];
    for (let cat of categories_list) {
      let cat_obj = {
        name: cat["name"],
        id: cat["id"],
        attributes: [],
      };
      // for (let attr of cat["attr_id"]) {
      //   if (attributes_list[attr]?.values.length > 0) {
      //     cat_obj["attributes"].push(attributes_list[attr]);
      //   }
      // }
      final_categories_list.push(cat_obj);
    }
    setMasterdata(final_categories_list);
  };
  useEffect(() => {
    if (industryId && !masterdata) {
      load_masterdata();
    }
  }, [industryId]);
  const validate_condition = (condition) => {
    if (condition.function === "FILTER" && condition.filter) {
      return validate_filter(condition.filter);
    } else if (
      ["AND", "OR"].includes(condition.function) &&
      condition.conditions
    ) {
      if (!condition.conditions || condition.conditions.length !== 2) {
        return "invalid conditions";
      }
      if (
        condition.conditions[0].function &&
        condition.conditions[0].function === "FILTER"
      ) {
        let validatefilter = validate_filter(condition.conditions[0].filter);
        if (validatefilter && validatefilter !== "") {
          return validatefilter;
        }
      }
      if (
        condition.conditions[1].function &&
        condition.conditions[1].function === "FILTER"
      ) {
        let validatefilter = validate_filter(condition.conditions[1].filter);
        if (validatefilter && validatefilter !== "") {
          return validatefilter;
        }
      }
      if (
        condition.conditions[0].function &&
        ["AND", "OR"].includes(condition.conditions[0].function)
      ) {
        let validatecondition = validate_condition(condition.conditions[0]);
        if (validatecondition && validatecondition !== "") {
          return validatecondition;
        }
      }
      if (
        condition.conditions[1].function &&
        ["AND", "OR"].includes(condition.conditions[1].function)
      ) {
        let validatecondition = validate_condition(condition.conditions[1]);
        if (validatecondition && validatecondition !== "") {
          return validatecondition;
        }
      }
    }
    return "";
  };

  const validate_filter = (filter) => {
    if (!filter) {
      return "Invalid Filter";
    }
    if (!filter.industries || filter.industries.length === 0) {
      return "Empty Industry";
    }
    if (
      (!filter.categories || filter.categories.length === 0) &&
      (!filter.attributes || filter.attributes.length === 0) &&
      (!filter.operator || filter.operator.length === 0) &&
      (!filter.values || filter.values.length === 0)
    ) {
      return "Invalid Filter";
    }
    if (
      (!filter.categories || filter.categories.length === 0) &&
      (!filter.operator ||
        !["EQ", "NOT_EQ", "LT", "LTE", "GT", "GTE", "RANGE"].includes(
          filter.operator
        ))
    ) {
      return "Invalid Operator";
    }
    if (
      (!filter.categories || filter.categories.length === 0) &&
      (!filter.attributes || !filter.attributes.length > 0)
    ) {
      return "Empty Categories and attributes";
    }
    if (
      filter.attributes &&
      filter.attributes.length > 0 &&
      (!filter.values || !filter.values.length > 0)
    ) {
      return "Empty Values";
    }
    if (
      (!filter.categories || filter.categories.length === 0) &&
      (!filter.values || !filter.values.length > 0)
    ) {
      return "Invalid values";
    }
    if (!filter.industries && filter.industries.length === 0) {
      return "Empty Industry";
    }
    if (
      filter.operator === "RANGE" &&
      (filter.min === "" || filter.max === "")
    ) {
      return "Min and Max values  are not added";
    }
    return "";
  };

  const validate_definition = (definition) => {
    if (!definition) {
      return "Empty definition";
    } else if (
      !definition.function ||
      !["FILTER", "AND", "OR"].includes(definition.function)
    ) {
      return "Invalid function";
    }
    if (definition.function === "FILTER" && definition.filter) {
      return validate_filter(definition.filter);
    } else if (
      ["AND", "OR"].includes(definition.function) &&
      definition.conditions
    ) {
      return validate_condition(definition);
    } else {
      return "Invalid definition";
    }
  };

  const validate_components = (component) => {
    if (!component) {
      return "Empty Component";
    } else if (!component.rank || typeof component.rank !== "number") {
      return "Invalid rank";
    } else if (
      !component.nessie ||
      !["REQUIRED", "DEFAULT", "OPTIONAL"].includes(component.nessie)
    ) {
      return "Invalid nessie";
    } else if (!component.component) {
      return "Components details not found";
    } else if (
      !component.component.display_name ||
      component.component.display_name === ""
    ) {
      return "Empty Component display_name";
    } else if (
      !component.component.unique_name ||
      component.component.unique_name === ""
    ) {
      return "Empty Component unique_name";
    } else if (
      !component.component.definition ||
      component.component.definition === ""
    ) {
      return "Empty Component definition";
    }
    try {
      return validate_definition(JSON.parse(component.component.definition));
    } catch (err) {
      return "Invalid definition";
    }
  };

  const validate_builder = (builder) => {
    if (!builder) {
      return "Empty dataset";
    }
    if (Object.keys(builder).length === 0) {
      return "Data Cannot be empty!!";
    } else if (!builder.builder) {
      return "Builder not found";
    } else if (!builder.builder.name || builder.builder.name === "") {
      return "Builder name cannot be empty";
    } else if (
      !builder.builder.short_name ||
      builder.builder.short_name === ""
    ) {
      return "Builder short name cannot be empty";
    } else if (!builder.components || builder.components.length < 1) {
      return "Builder Components cannot be empty";
    }
    for (let comp of builder.components) {
      let result = validate_components(comp);
      if (result) return result;
    }
    return "";
  };

  const format_builder = (builder, global_filter = []) => {
    let final_builder = {
      node: {
        name: builder.builder.name,
        description: builder.builder.description,
        global_filter: global_filter,
        short_name: builder.builder.short_name,
        is_deleted: builder.builder.is_deleted ?? false,
      },
      components: [],
    };
    
    for (let comp of builder.components) {
      let final_comp = {
        node: {
          unique_name: comp.component.unique_name,
          display_name: comp.component.display_name,
          description: comp.component.description,
          is_deleted: comp.component?.is_deleted ?? false,
        },
        nessie: comp.nessie,
        rank: comp.rank,
        definition: JSON.parse(comp.component.definition),
      };
      final_builder.components.push(final_comp);
    }
    return final_builder;
  };

  return (
    <BuilderContext.Provider
      value={{
        industryId,
        partyId,
        categoriesList,
        attributesList,
        masterdata,
        builder_template,
        component_template,
        filter_template,
        condition_template,
        validate_builder,
        format_builder,
        platformInfo,
        globalFilter,
        setGlobalFilter,
        selectedAttr,
        setSelectedAttr,
      }}
    >
      {children}
    </BuilderContext.Provider>
  );
};
